import axios from 'axios'
import { NRLogger } from '../../modules/logging/nrLogging'

export default class CustomerProfileService {
  async getCustomerProfile(authorizationHeader) {
    return this.getProfile(authorizationHeader)
  }

  async getProfile(authorizationHeader) {
    const url = 'https://profile.cimpress.io/v1/ozoDdrmewShEcbUDWX8J3V/profile/me'

    const result = await axios({
      method: 'get',
      url,
      headers: {
        Accept: 'application/json',
        Authorization: authorizationHeader,
      },
    })
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        // set an exception for 403 errors
        if (error && error.response && error.response.status && error.response.status === 403) {
          // Skip this error as it's related to an anonymous token (no need to be alerted)
          return {}
        }

        NRLogger.error('UBIK Help Center - Get Customer Profile', {
          url,
          status: error.response?.status,
          message: 'Error occurred while getting customer profile',
          stack: JSON.stringify(error),
        })
        return {}
      })
    return result
  }
}
